import type { CSSProperties } from 'react';

interface FighterTileProps {
  imageUrl: string;
  label?: string;
  selected?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  index?: number;
  total?: number;
}

export function FighterTile({
  imageUrl,
  label,
  selected = false,
  disabled = false,
  onClick,
  index,
  total,
}: FighterTileProps) {
  const progress =
    typeof index === 'number' && typeof total === 'number' && total > 1
      ? index / (total - 1)
      : 0;
  const style = { '--tile-progress': progress } as CSSProperties;

  return (
    <button
      type="button"
      className={`smash-fighter-tile${selected ? ' smash-fighter-tile--selected' : ''}${disabled ? ' smash-fighter-tile--disabled' : ''}`}
      disabled={disabled}
      onClick={onClick}
      style={style}
    >
      <img
        className="smash-fighter-tile__img"
        src={imageUrl}
        alt={label || ""}
        loading="lazy"
      />
      {label && <span style={{ textTransform: 'uppercase' }}>{label}</span>}
    </button>
  );
}
